import { Button } from '@/shared/components/ui/button';
import { CustomLink } from '@/shared/components/ui/custom-link';

const NotAllowed = () => {
  return (
    <div className="$tw-flex $tw-h-full $tw-flex-col $tw-items-center $tw-justify-center $tw-gap-4">
      <h2 className="$tw-font-semibold">No está autorizado para acceder a esta página</h2>
      <p className="$tw-text-xl">Contacte con el administrador del sistema para obtener acceso.</p>
      <Button variant="secondary" className="$tw-text-foreground" asChild>
        <CustomLink to="/">Volver a la página de inicio</CustomLink>
      </Button>
    </div>
  );
};

export default NotAllowed;
